// @flow
import { type ActionType } from 'redux-actions';
import {
  requestChannelContent,
  receiveChannelContent,
} from './channelContentActions';
import { call, select, takeLatest, put } from 'redux-saga/effects';
import { selectToken } from 'ducks/SagaUtils';
import { addItemsTask } from 'ducks/coreDataSaga';
import { normalizeSearchResponse } from 'containers/search/normalizeSearchResponse';

function* fetchChannelContent(
  action: ActionType<typeof requestChannelContent>
) {
  const { apiMethod, channelName, endDateTime, pageNumber } = action.payload;
  const token = yield select(selectToken);

  try {
    const response = yield call(apiMethod, token, endDateTime, pageNumber);

    // Pwr-distro: [{ugc_results: [...]}] needs unwrapping
    // Non-distro: [{subject, ugc}, ...] is already an array
    let unwrappedResponse = response;
    if (
      Array.isArray(response) &&
      response.length === 1 &&
      response[0].ugc_results
    ) {
      unwrappedResponse = response[0];
    }

    const normalizedResponse = normalizeSearchResponse(unwrappedResponse);

    const items = Array.isArray(normalizedResponse) ? normalizedResponse : [];

    const itemsToPut = yield call(addItemsTask, {
      data: { items },
    });

    // Extract total_pages from pwr-distro response
    const totalPages =
      unwrappedResponse.total_pages != null
        ? unwrappedResponse.total_pages
        : undefined;

    yield put.resolve(
      receiveChannelContent(channelName, itemsToPut.items, totalPages)
    );
  } catch (err) {
    console.error(err);
    yield put.resolve(receiveChannelContent(channelName, err));
  }
}

export default function*(collectionId: string): Generator<*, *, *> {
  yield takeLatest(requestChannelContent, fetchChannelContent);
}



// WEBPACK FOOTER //
// ./src/containers/channels/ducks/channelContentSaga.js